import { gql } from "@apollo/client";

export const GET_DISBURSEMENT_BY_DATE = gql`
  query GetDisbursementByDate($date: String!) {
    getDisbursementByDate(date: $date) {
      _id
      date
      numbering
      lastSave
      lastUpdatedBy {
        _id
        firstName
        lastName
        email
        password
        userProfile
        role
        createdAt
      }
      items {
        groupName
        groupId
        expensesType {
          expenseName
          expenseId
          supplierName
          supplierId
          invoiceNumber
          qty
          unitPriceKHR
          unitPriceUSD
        }
      }
      totalInUSD
      totalInKHR
      createdBy {
        _id
        firstName
        lastName
        email
        password
        userProfile
        role
        createdAt
      }
      createdAt
    }
  }
`;

export const ADD_DISBURSEMENT = gql`
  mutation AddDisbursement($date: String!) {
    addDisbursement(date: $date) {
      status
      message
    }
  }
`;

export const GET_DISBURSEMENTS_WITH_PAGINATION = gql`
  query GetDisbursementsPagination(
    $page: Int!
    $limit: Int!
    $to: Date!
    $from: Date!
  ) {
    getDisbursementsPagination(
      page: $page
      limit: $limit
      to: $to
      from: $from
    ) {
      data {
        _id
        date
        numbering
        createBy
        createBysrc
        updatedBy
        updatedBysrc
        items
        lastSaveAt {
          date
          time
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const GET_DISBURSEMENT_BY_ID = gql`
  query GetDisbursementId($id: ID!) {
    getDisbursementId(_id: $id) {
      _id
      date
      numbering
      disbursements {
        accountType
        accountTypeId
        uniqueId
        code_account
        items {
          itemUniqueId
          invDate
          invNo
          description
          supplierId
          supplierName
          qty
          exchangeRate
          priceUSD
          priceKHR
          payments {
            paymentDate
            paymentMethod
            pricePaidUSD
            pricePaidKHR
          }
        }
      }
      createBy
      updatedBy
      updatedBysrc
      createBysrc
      lastSaveAt {
        date
        time
      }
      totalUSD
      totalKHR
    }
  }
`;

export const DELETE_DISBURSEMENT = gql`
  mutation DeleteDisbursement($id: ID!) {
    deleteDisbursement(_id: $id) {
      status
      message
    }
  }
`;

export const UPDATE_DISBURSEMENT = gql`
  mutation UpdateDisbursement($id: ID!, $input: [inputDisbursement]) {
    updateDisbursement(_id: $id, input: $input) {
      status
      message
    }
  }
`;

export const GET_EXCHANGE_RATE = gql`
  query Query {
    getExchangRate
  }
`;

export const PAY_DISBURSEMENT = gql`
  mutation PayDisbursement($id: ID!, $input: [PayDisbursementInput]) {
    payDisbursement(_id: $id, input: $input) {
      status
      message
    }
  }
`;
